export { default } from './CatalogCard';
export type { CatalogCardProps } from './types';
